import { MobileOS } from '@/common/utils/getMobileOS'
import { ANALYTICS_EVENTS } from '../../events'
import createAnalyticsStatic, { EventProps } from '../createAnalyticsEvent'

export interface InstallAppPromotionShownProps extends EventProps {
    OS: MobileOS
}

/**
 * @event PWA Install App Promotion Shown
 */
export const InstallAppPromotionShownAnalytics = createAnalyticsStatic<InstallAppPromotionShownProps>(
    ANALYTICS_EVENTS.PWA.INSTALL_APP_PROMOTIONS_SHOWN,
)

export default InstallAppPromotionShownAnalytics
